export enum PublicProductSortType {
  NameAscending,
  NameDescending,
  CreatedAtAscending,
  CreatedAtDescending,
}
